import React from 'react';
import Icon from 'components/DesignSystem/Icon';
import { SortDirection, SORT_ASC, SORT_DESC } from 'constants/sorting';
import { cssVar } from 'constants/theme';
import { useClosure } from 'utils/hooks';
import { Button, Stack } from 'react-bootstrap';
import { nextDirection, SortableField, Sorter } from './helpers';
import './index.scss';

export { useSorting } from './helpers';

export interface SortingArrowProps {
  field: string;
  sort: Sorter;
  sortBy: SortableField;
  sortDirection: SortDirection | undefined;
}

export default function SortingArrow({
  field,
  sortBy,
  sortDirection,
  sort,
}: SortingArrowProps) {
  const realDirection = sortBy === field ? sortDirection : undefined;
  const onClick = useClosure(nextDirection, sort, realDirection);
  const id = `${field}-sort`;
  const upColor = cssVar(realDirection === SORT_DESC ? 'text-disabled' : 'text');
  const downColor = cssVar(realDirection === SORT_ASC ? 'text-disabled' : 'text');
  return (
    <Button id={id} className="sorting-arrow" onClick={onClick}>
      <Stack gap={0}>
        <Icon iconType="up_arrow" color={upColor} />
        <Icon iconType="down_arrow" color={downColor} />
      </Stack>
    </Button>
  );
}
